/**
 * This file is auto-generated from ChatSubscriptionStart.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const subscriptionStarted: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Subscription started';
        case 'pl':
            return 'Subskrypcja aktywna';
    }
};
